import { NgModule } from '@angular/core';
import { RescheduleMeetingButtonComponent } from './reschedule-meeting-button/reschedule-meeting-button.component';
import { RescheduleMeetingDialogComponent } from './reschedule-meeting-dialog/reschedule-meeting-dialog.component';
import { MeetingSchedulerSharedModule } from '../../shared/meeting-scheduler-shared.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';

@NgModule({
  declarations: [RescheduleMeetingButtonComponent, RescheduleMeetingDialogComponent],
  exports: [RescheduleMeetingButtonComponent],
  imports: [
    MatTooltipModule,
    MatButtonModule,
    MatIconModule,
    TranslateModule,
    CommonModule,
    GalaxyFormFieldModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatInputModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatSelectModule,
    MeetingSchedulerSharedModule,
  ],
})
export class RescheduleMeetingButtonModule {}
